/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccountId } from "../../commons/types/AccountId";
import { AppId } from "../../commons/types/AppId";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { SpaceId } from "../../commons/types/SpaceId";
import { RunbookConfig } from "./RunbookConfig";
import { RunbookStatus } from "./RunbookStatus";
import { RunbookType } from "./RunbookType";
export const CreateRunbookRequest = core.serialization.object({
    accountId: AccountId,
    appId: AppId,
    environmentId: EnvironmentId,
    spaceId: SpaceId,
    name: core.serialization.string(),
    config: RunbookConfig,
    status: RunbookStatus,
    type: RunbookType,
});
